import type ModalConversationInterceptorService from '../../modals/modal-conversation-interceptor.service';

export class UserInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ReaderHasDebtOnRegistrationFeeException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ReaderHasReservationReadyException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ReaderHasReservationException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserIsMemberOfGroupException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserIsRepresentativeOfGroupException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('GroupHasMembersException');
        this.modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('UserDeletionWithAdditionalFieldsException');


        this.modalConversationInterceptor.registerUserPreferenceExceptionHandler('UserPreferenceNotSetException');

    }

}
